import React from "react";
import generalInfo from "../../assets/generalInfo.pdf";

const HomeBody = () => (
  <div className="homeBody">
    <div>
      <h1 className="homeBody__header">
        Welcome to the KCPAO Search Warrant Resource Center
      </h1>
      <h4 className="homeBody__subHeader">
        Click the appropriate tab above to navigate this site.
      </h4>
      <h4 className="homeBody__subHeader">
        For general questions about the felony Search Warrant practice in King
        County –{" "}
        <a className="homeBody__subHeader" href={generalInfo}>
          click here
        </a>
      </h4>
    </div>
    <div className="homeBody__footer">
      For feedback on the content of this site, suggestions for improvements, or
      requests for additional templates, please contact{" "}
      <a href="mailto:PAOSpecOps@kingcounty.gov">
        <b>PAOSpecOps@kingcounty.gov</b>
      </a>
      <br /><br />
      <span>This website was created and is maintained by the King County Prosecuting Attorney's Office Special Operations Unit:</span>
      <div className="homeBody__footer--indent">
        <span>Gary Ernsdorff, Supervising Attorney: <a href="mailto:Gary.Ernsdorff@kingcounty.gov">Gary.Ernsdorff@kingcounty.gov</a></span><br />
        <span>Lindsey Thomas, Project/Program Manager: <a href="mailto:Lindsey.Thomas@kingcounty.gov">Lindsey.Thomas@kingcounty.gov</a></span><br />
        <span>Hollie Nuanes, Paralegal: <a href="mailto:hnuanes@kingcounty.gov">hnuanes@kingcounty.gov</a></span>
      </div>
    </div>
  </div>
);

export default HomeBody;
